<template>
  <v-btn-toggle v-model="model" class="btn-toggle mr-1" :mandatory="mandatoryComputed" rounded>
    <v-btn v-for="(c, index) in category" :key="index" :value="c[itemValue]" :disabled="disabled">{{
      c[itemText]
    }}</v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: 'BtnToggle',

  components: {},

  props: {
    value: {
      type: [String, Boolean],
      required: true,
    },
    category: {
      type: Array[Object],
      required: true,
    },
    itemText: {
      type: String,
      required: true,
    },
    itemValue: {
      type: String,
      required: true,
    },
    mandatory: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: () => ({}),

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    mandatoryComputed() {
      return this.mandatory
    },
  },

  methods: {},
}
</script>

<style>
/** ボタン活性・選択済み */
.btn-toggle > .v-btn.v-btn--active {
  color: #ffffff !important;
  background-color: var(--v-primary-base) !important;
}

/** ボタン活性・未選択 */
.btn-toggle > .v-btn {
  color: #000000 !important;
  background-color: #ffffff !important;
}

/** ボタン非活性・選択済み */
.btn-toggle > .v-btn.v-btn--active.v-btn--disabled {
  color: #ffffff !important;
}
.btn-toggle > .v-btn.v-btn--active.v-btn--disabled.v-btn--has-bg {
  background-color: #898989 !important;
}

/** ボタン非活性・未選択 */
.btn-toggle > .v-btn.v-btn--disabled {
  color: #898989 !important;
}
.btn-toggle > .v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #eeeeee !important;
}
</style>
